import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <h4>Built with 🪄</h4>
    </footer>
  );
};

export default Footer;
